(function () {
  'use strict';
  function validate(action = {}) {
    let returnable;
    if (
      angular.isNumber(action.amount) &&
      angular.isNumber(action.timestamp) &&
      angular.isString(action.categoryId)
    ) {
      returnable = true;
    }
    return returnable;
  }
  function reducer(action, $firedux) {
    let uid = $firedux.var('UID');
    return $firedux
      .ref('categories')
      .child(action.categoryId)
      .child('reviews')
      .child(uid)
      .set({
        timestamp: action.timestamp,
        amount: action.amount
      });
  }
  angular
    .module('reducers')
    .run(run);
  function run($firedux) {
    $firedux.reducer({
      trigger: 'CATEGORY.ADD_REVIEW',
      reducer: function (action) {
        return validate(action) ?
          reducer(action, $firedux) :
          Promise.reject('VALIDATION ERROR');
      }
    });
  }
}());
